export const FETCH_EPG_CHANNEL_INIT = 'FETCH_EPG_CHANNEL_INIT';
export const FETCH_EPG_CHANNEL_SUCCESS = 'FETCH_EPG_CHANNEL_SUCCESS';
export const FETCH_EPG_CHANNEL_ERROR = 'FETCH_EPG_CHANNEL_ERROR';
